import { BsTwitterX } from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa";
import { FaRegCopyright } from "react-icons/fa";
import { FaSnapchatGhost } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import { Link } from "react-router-dom";
import React from "react";
import { RiInstagramFill } from "react-icons/ri";
import americanExpress from "../../assets/images/amircanexpress.jpg";
import app_gallery from "../../assets/images/Layer_1.png";
import app_store from "../../assets/images/App Store.png";
import googlePay from "../../assets/images/googlepay.jpg";
import google_play from "../../assets/images/google-play-badge (2).png";
import logo_full from "../../assets/images/Logo_white.png";
import mada from "../../assets/images/mada.png";
import master from "../../assets/images/master.png";
import pay from "../../assets/images/pay.png";
import stcPay from "../../assets/images/stcpay.jpg";
import tamara from "../../assets/icons/tamara.png";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import visa from "../../assets/images/visa.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { categories } = useSelector((state) => state.categories);

  const { t, i18n } = useTranslation();

  return (
    <div
      className="flex items-center justify-center w-screen 
        text-white bg-[#402D7E]"
    >
      <div
        className="w-[90%] lg:w-[85%] flex flex-col 
      items-start justify-center py-10"
      >
        <div
          className="w-full flex flex-col lg:flex-row justify-center 
        items-stretch gap-12 lg:gap-14 border-b-2 border-white py-3"
        >
          {/* logo - desc - social icons */}
          <div className="flex items-start justify-between flex-col gap-6 flex-grow">
            {/* logo - desc */}
            <div className="flex items-start justify-start flex-col gap-6">
              {/* logo */}
              <div>
                <Link to="/">
                  <img
                    src={logo_full}
                    alt="spring_rose"
                    className=" h-[62.26px] object-cover"
                  />
                </Link>
              </div>
              {/* desc */}
              <p className="text-sm">
                {t("footerText")}
              </p>
            </div>
            {/* social icons */}
            <div className="flex flex-col items-start justify-center gap-2">
              <p>{t("followUs")}</p>
              <div className="flex items-center justify-center gap-3">
                <div
                  className="w-[2.75rem] h-[2.75rem] flex items-center 
            justify-center  rounded-full text-white border-2 border-white"
                >
                  <Link>
                    <FaFacebookF size={24} />
                  </Link>
                </div>
                <div
                  className="w-[2.75rem] h-[2.75rem] flex items-center 
            justify-center  rounded-full text-white border-2 border-white"
                >
                  <Link>
                    <RiInstagramFill size={24} />
                  </Link>
                </div>
                <div
                  className="w-[2.75rem] h-[2.75rem] flex items-center 
            justify-center  rounded-full text-white border-2 border-white"
                >
                  <Link>
                    <FaSnapchatGhost size={24} />
                  </Link>
                </div>
                <div
                  className="w-[2.75rem] h-[2.75rem] flex items-center 
            justify-center  rounded-full text-white border-2 border-white"
                >
                  <Link>
                    <BsTwitterX size={24} />
                  </Link>
                </div>
                <div
                  className="w-[2.75rem] h-[2.75rem] flex items-center 
            justify-center  rounded-full text-white border-2 border-white"
                >
                  <Link>
                    <FaTiktok size={24} />
                  </Link>
                </div>
                <div
                  className="w-[2.75rem] h-[2.75rem] flex items-center 
            justify-center  rounded-full text-white border-2 border-white"
                >
                  <Link>
                    <IoMail size={24} />
                  </Link>
                </div>
              </div>
            </div>
          </div>
          {/* Company - customer services */}
          <div className="flex items-start justify-start lg:justify-center gap-12 w-full">
            {/* Company */}
            <div className="flex flex-col items-start justify-start gap-2 text-sm">
              <h1 className="text-lg font-semibold mb-3">{t("springRose")}</h1>
              {categories.map((category) => (
                <Link key={category.id} to={`/categories/${category.id}`}>
                  <p className="text-sm font-normal text-white">
                    {i18n.language === "en"
                      ? category?.english_name
                      : category?.arabic_name}
                  </p>
                </Link>
              ))}
            </div>
            {/* customer servies */}
            <div className="flex flex-col items-start justify-start gap-2">
              <h1 className="text-xl font-semibold mb-3">{t("customerServices")}</h1>
              <Link to="/profile">
                <p className="text-sm font-normal text-white">{t("myAccount")}</p>
              </Link>
              <Link to="/track-order">
                <p className="text-sm font-normal text-white">{t("trackYourOrder")}</p>
              </Link>
              <Link to="/shipping-policy">
                <p className="text-sm font-normal text-white">{t("shippingPolicy")}</p>
              </Link>
              <Link to="/privacy-policy">
                <p className="text-sm font-normal text-white">{t("privacyPolicy")}</p>
              </Link>
              <Link to="/terms-conditions">
                <p className="text-sm font-normal text-white">{t("termsConditions")}</p>
              </Link>
              <Link to="/about-us">
                <p className="text-sm font-normal text-white">{t("aboutUs")}</p>
              </Link>
              <Link to="/contact-us">
                <p className="text-sm font-normal text-white">{t("contactUs")}</p>
              </Link>
              <Link to="/faqs">
                <p className="text-sm font-normal text-white">{t("faq")}</p>
              </Link>
            </div>
          </div>
          {/* Ouer Info - contact Info */}
          <div className="flex items-start justify-start lg:justify-center gap-12 w-full">
            {/* contact-info */}
            <div className="flex flex-col items-start justify-start gap-2 ">
              <h1 className="text-xl font-semibold">{t("downloadOurApp")}</h1>
              <a
                href="https://apps.apple.com/sa/app/%D8%B2%D9%87%D8%B1%D8%A9-%D8%A7%D9%84%D8%B1%D8%A8%D9%8A%D8%B9-springrose/id6705133425"
                target="_blank"
                rel="noopener noreferrer">
                <img
                  src={app_store}
                  alt=""
                  className="w-[121px] h-[36px] object-cover"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.spring.rose"
                target="_blank"
                rel="noopener noreferrer">
                <img
                  src={google_play}
                  alt=""
                  className="w-[121px] h-[36px] object-cover"
                />
              </a>
              <a
                href="https://appgallery.huawei.com/app/C114509381"
                target="_blank"
                rel="noopener noreferrer">
                <img
                  src={app_gallery}
                  alt=""
                  className="w-[121px] h-[36px] object-cover"
                />
              </a>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-between w-full 
        flex-col lg:flex-row gap-3 lg:gap-0 py-4">
          {/* copyRight */}
          <div
            className="flex items-start justify-center gap-1 mt-2 
        whitespace-nowrap text-sm lg:text-base "
          >
            {t("copyRight")}
            <span>
              <FaRegCopyright className="translate-y-1" />
            </span>{" "}
            <span> {currentYear}</span>
            {t("allRightsReserved")}
          </div>
          <div className="flex items-center justify-center gap-2">
            <div>
              <img src={mada} alt="mada" className="w-[47px] h-[25px] object-cover" />
            </div><div>
              <img src={tamara} alt="tamara" className="w-[47px] h-[25px] object-cover" />
            </div>
            <div>
              <img src={pay} alt="pay" className="w-[47px] h-[25px] object-cover" />
            </div>
            <div>
              <img src={master} alt="master" className="w-[47px] h-[25px] object-cover" />
            </div>
            <div>
              <img src={visa} alt="visa" className="w-[47px] h-[25px] object-cover" />
            </div>
            <div>
              <img src={googlePay} alt="google_pay" className="w-[47px] h-[25px] object-cover" />
            </div>
            <div>
              <img src={stcPay} alt="stc_pay" className="w-[47px] h-[25px] object-cover" />
            </div>
            <div>
              <img src={americanExpress} alt="american_express" className="w-[47px] h-[25px] object-cover" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Footer;
